/**
 * Helpers for converting per-folder import options into the shape that
 * CloudFileTree expects for visual filtering.
 */

export interface FolderImportOptionsLike {
  maxFolderDepth: number;
  filterByExtension: boolean;
  selectedExtensions: string[];
}

/**
 * Build a map of folder path → allowed extensions, keeping only folders whose
 * extension filter is enabled AND that have at least one extension configured.
 *
 * When `selectedPaths` is provided, also drops entries whose path is not in
 * the set — prevents stale filters from lingering when a folder is deselected
 * via the tree checkbox (which doesn't prune folderOptions itself).
 */
export const toActiveExtensionFilters = (
  folderOptions: Map<string, FolderImportOptionsLike>,
  selectedPaths?: Set<string>,
): Map<string, string[]> => {
  const active = new Map<string, string[]>();
  for (const [path, options] of folderOptions) {
    if (selectedPaths && !selectedPaths.has(path)) continue;
    if (options.filterByExtension && options.selectedExtensions.length > 0) {
      active.set(path, options.selectedExtensions);
    }
  }
  return active;
};
